import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeColor } from '@view-model/models/common/color';
import { ZoneColorSwatch } from './ZoneColorSwatch';

type ClientPoint = { x: number; y: number };

type Props = {
  isOpen: boolean;
  onClickColor: (color: ThemeColor) => void;
  onColorDrag: (clientPoint: ClientPoint, color: ThemeColor) => void;
  onColorDragEnd: (clientPoint: ClientPoint, color: ThemeColor) => void;
  onColorDragCancel: () => void;
};

export const ZoneColorPalette: React.FC<Props> = ({
  isOpen,
  onClickColor,
  onColorDrag,
  onColorDragEnd,
  onColorDragCancel,
}: Props) => {
  const { t } = useTranslation();
  const colors = useMemo(() => ThemeColor.values(), []);

  if (!isOpen) return null;

  return (
    <div
      role="group"
      aria-label={t('viewModel.toolbar.zoneColorPalette')}
      className="pointer-events-auto absolute left-full top-0 z-50 ml-2 flex flex-col gap-1 rounded-lg bg-white p-2 shadow-2xl"
    >
      {colors.map((color) => (
        <ZoneColorSwatch
          key={color}
          color={color}
          onClick={onClickColor}
          onDrag={onColorDrag}
          onDragEnd={onColorDragEnd}
          onDragCancel={onColorDragCancel}
        />
      ))}
    </div>
  );
};
